import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@root/src/environments/environment';

/** Body and response of PUT /assignments/processes/{processKey}/failure-policy. */
export interface ProcessFailurePolicyDto {
  interruptionPolicy: string;
  resumeAttemptLimit: number;
  pauseAfterConsecutiveFailures: number;
}

/**
 * Process failure policy.
 * TODO: migrate to api-client when PUT /assignments/processes/{processKey}/failure-policy is generated.
 */
@Injectable({ providedIn: 'root' })
export class ProcessFailurePolicyService {
  private readonly http = inject(HttpClient);

  save(processKey: string, body: ProcessFailurePolicyDto): Observable<ProcessFailurePolicyDto> {
    const url = `${environment.api}/assignments/processes/${encodeURIComponent(processKey)}/failure-policy`;
    return this.http.put<ProcessFailurePolicyDto>(url, body);
  }
}
